import React, { useState } from 'react';
import { useGetImagesQuery } from './ImgurApiSlice';
import { Grid, Box, CircularProgress, Typography, Skeleton } from '@mui/material';
import LazyLoad from 'react-lazyload';

const Imgur = () => {
  const { data, error, isLoading } = useGetImagesQuery();

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return <Typography variant="h6" color="error">Error fetching images.</Typography>;
  }

  if (!data || !data.ids || data.ids.length === 0) {
    return <Typography variant="h6">No images available</Typography>;
  }

  const images = data.ids.map(id => data.entities[id]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', width: '100%' }}>
      <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ maxWidth: '1200px', width: '100%' }}>
        {images.map((image) => (
          <Grid item xs={12} sm={6} md={4} lg={6} key={image.id}>
            <LazyLoad height={200} offset={100} once>
              <ImageWithSkeleton src={image.image} alt={image.title || "Image"} />
            </LazyLoad>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const ImageWithSkeleton = ({ src, alt }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <Box sx={{ width: '100%', minHeight: '200px', position: 'relative' }}>
      {/* Show Skeleton while image is loading */}
      {!loaded && <Skeleton variant="rectangular" width="100%" height={283} />}

      {/* Show image when loaded */}
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onLoad={() => {
          setLoaded(true);
        }}
        onError={() => console.error(`Failed to load image: ${src}`)}
        style={{
          width: '100%',
          height: 'auto',
          borderRadius: '8px',
          objectFit: 'cover',
          visibility: loaded ? 'visible' : 'hidden', // Prevents layout shift
        }}
      />
    </Box>
  );
};

export default Imgur;
